import React from "react";
import PortfolioInformation from "./portfolioInformation";

function Index() {
  return <PortfolioInformation />;
}

export default Index;
